import { api } from "../../service/rtk";
import { ENDPOINTS } from "../../service/url";

export const cmsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getCmsData: builder.query({
            query: () => ({
                url: ENDPOINTS.CMS,
                method: "GET",
            }),
            providesTags: ["CMS"],
        }),
        updateCmsData: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.CMS,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["CMS"],
        }),
        getFaqs: builder.query({
            query: ({ page, limit = 10 }) => ({
                url: ENDPOINTS.FAQS,
                method: "GET",
                params: { page, limit },
            }),
            providesTags: ["CMS"],
        }),
        addFaq: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.FAQS,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["CMS"],
        }),
        updateFaq: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.FAQS}/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["CMS"],
        }),
        deleteFaq: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.FAQS}/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["CMS"],
        }),
        getBanners: builder.query({
            query: ({ page, limit = 10 }) => ({
                url: ENDPOINTS.BANNERS,
                method: "GET",
                params: { page, limit },
            }),
            providesTags: ["CMS"],
        }),
        addBanner: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.BANNERS,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["CMS"],
        }),
        updateBanner: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.BANNERS}/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["CMS"],
        }),
        deleteBanner: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.BANNERS}/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["CMS"],
        }),
        updateBannerStatus: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.BANNERS}/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["CMS"],
        }),
        getVehicleBanners: builder.query({
            query: ({ page, limit = 10 }) => ({
                url: ENDPOINTS.VEHICLE_BANNERS,
                method: "GET",
                params: { page, limit },
            }),
            providesTags: ["CMS"],
        }),
        addVehicleBanner: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.VEHICLE_BANNERS,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["CMS"],
        }),
        deleteVehicleBanner: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.VEHICLE_BANNERS}/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["CMS"],
        }),
        getVehicleBannerById: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.VEHICLE_BANNERS}/${id}`,
                method: "GET",
            }),
            providesTags: ["CMS"],
        }),
        updateVehicleBanner: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.VEHICLE_BANNERS}/${id}`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["CMS"],
        }),
        getCategoryBanners: builder.query({
            query: ({ page, limit = 10 }) => ({
                url: ENDPOINTS.CATEGORY_BANNERS,
                method: "GET",
                params: { page, limit },
            }),
            providesTags: ["CMS"],
        }),
        getCategoryBannerById: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.CATEGORY_BANNERS}/${id}`,
                method: "GET",
            }),
            providesTags: ["CMS"],
        }),
        addCategoryBanner: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.CATEGORY_BANNERS,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["CMS"],
        }),
        updateCategoryBanner: builder.mutation({
            query: ({ id, image }) => ({
                url: `${ENDPOINTS.CATEGORY_BANNERS}/${id}`,
                method: "POST",
                body: { image },
            }),
            invalidatesTags: ["CMS"],
        }),
        deleteCategoryBanner: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.CATEGORY_BANNERS}/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["CMS"],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetCmsDataQuery,
    useUpdateCmsDataMutation,
    useGetFaqsQuery,
    useAddFaqMutation,
    useUpdateFaqMutation,
    useDeleteFaqMutation,
    useGetBannersQuery,
    useAddBannerMutation,
    useUpdateBannerMutation,
    useDeleteBannerMutation,
    useUpdateBannerStatusMutation,
    useGetVehicleBannersQuery,
    useAddVehicleBannerMutation,
    useDeleteVehicleBannerMutation,
    useGetVehicleBannerByIdQuery,
    useUpdateVehicleBannerMutation,
    useGetCategoryBannersQuery,
    useGetCategoryBannerByIdQuery,
    useAddCategoryBannerMutation,
    useUpdateCategoryBannerMutation,
    useDeleteCategoryBannerMutation,
} = cmsApi;
